<template>
  <div id="app">
    <component :is="layout" />

    <ToastContainer />
    <ToastContainer2 />
  </div>
</template>

<script>
import ToastContainer from "@/components/utils/ui_v4/alerts/toast/ToastContainer.vue";
import ToastContainer2 from "@/components/utils/ui_v4/alerts/toast/ToastContainer2.vue";

export default {
  name: 'App',
  components: { ToastContainer, ToastContainer2 },
  computed: {
    layout() {
      const meta = this.$route.meta;
      return meta.layout ? meta.layout + '-layout' : 'systock-layout';
    }
  }
};
</script>

<style>
/* DICA: Como adicionamos uma div envolta (#app)*/
html, body, #app {
  margin: 0;
}
</style>
